import React, { FC } from "react";

import Modal from "./Modal";
import { Button } from "../Base";

interface ConfirmModalProps {
  onClose: () => void;
  onSubmit: () => void;
}

const ConfirmModal: FC<ConfirmModalProps> = ({ onClose, onSubmit }) => {
  return (
    <Modal close={onClose}>
      <div
        style={{ width: 520 }}
        className="p-3 z-3 bg-white flex flex-column justify-content-center align-items-center rounded-2 shadow"
      >
        <div className="mb-2 pb-3 pt-1 border-bottom d-flex justify-content-start  align-items-center gap-2">
          <i className="bi bi-trash text-danger fs-5 d-flex" />
          <p className="fw-bold m-0">آیا از حذف اطمینان دارید؟</p>
        </div>
        <div className="d-flex justify-content-end gap-2 w-100 align-items-center">
          <Button
            btnClass="text-danger border border-danger w-25 mb-0"
            text="انصراف"
            onClick={onClose}
          />
          <Button
            btnClass="bg-danger text-white w-25 mb-0"
            text="حذف"
            onClick={onSubmit}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
